import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
    Aangifte, Adres, BokkzAlgDataService, IncomeTaxEntity, OmschrijvingEnBedrag,
    OnroerendeZaak, OnroerendeZaakLeegstand, Periode
} from '@snelstart-ventures/fiscaal/domain-logic';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { BokkzIbDataService } from '@snelstart-ventures/fiscaal/domain-logic';
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import {
    optionsLandcodesMetNLD
} from '../../../gedeelde-componenten/gedeelde-componenten.component';
import { filter, Subscription } from 'rxjs';
import { Event, NavigationEnd, Router } from '@angular/router';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { CommonModule } from '@angular/common';


@Component({
    selector: 'snelstart-venture-fiscaal-feature-eigenwoningen',
    templateUrl: './eigenwoningen.component.html',
    styleUrls: ['./eigenwoningen.component.scss'],
    imports: [
        SharedUiDetailsModule,
        SharedUiFormControlsModule,
        SharedUiButtonModule,
        SharedUiDialogModule,
        CommonModule
    ]
})
export class EigenwoningenComponent implements OnInit, OnDestroy {

    @Input() public id!: string;
    public clientId!: string;
    protected readonly OnroerendeZaakLeegstand = OnroerendeZaakLeegstand;
    private focusedElementId: string | null = null;
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private eigenWoningSubscription: Subscription | undefined;
    private eigenWoningenSubscription: Subscription | undefined;
    private isSaving = false;
    private formStructure: any;
    private eigenWoningLength: any;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    public dialogVisible = false;
    public eigenWoningFG = {} as FormGroup;
    public labelWoz = '';
    public index = 0;

    public optionsJaNee: SelectFormControlItem<boolean | undefined>[] = [
        { value: true, label: 'Ja' },
        { value: false, label: 'Nee' }
    ];

    public optionsJaNeeAanhorigheid: SelectFormControlItem<boolean | undefined>[] = [
        { value: false, label: 'Nee, geen aanhorigheid' },
        { value: true, label: 'Ja, wel aanhorigheid' }
    ];

    public optionsLandcodes: SelectFormControlItem<string>[] = optionsLandcodesMetNLD;

    public redenLeegstand: SelectFormControlItem<string>[] = [
        { value: '', label: '--- selecteer ---' },
        { value: OnroerendeZaakLeegstand.VERKOOP, label: 'Woning staat/stond te koop en wordt/is verkocht' },
        { value: OnroerendeZaakLeegstand.AANBOUW, label: 'Woning is/was in aanbouw/bouwkavel' },
        { value: OnroerendeZaakLeegstand.EX, label: 'Woning is/was bewoond door ex-partner' },
        { value: OnroerendeZaakLeegstand.VERZORGINGSTEHUIS, label: 'Onbewoond door vertrek naar verzorgingstehuis' },
        { value: OnroerendeZaakLeegstand.UITZENDING, label: 'Onbewoond door uitzending naar buitenland' }
    ];

    showDialog(index: number) {
        this.index = index;
        this.dialogVisible = true;
    }

    constructor(private fb: FormBuilder, private router: Router, public dataService: BokkzIbDataService, private dataAlgService: BokkzAlgDataService) {
        this.eigenWoningFG = this.fb.group({
            eigenWoningen: this.fb.array<OnroerendeZaak>([])
        });
    }

    get eigenWoningen(): FormArray {
        return this.eigenWoningFG.get('eigenWoningen') as FormArray;
    }

    addEigenWoning(): void {
        const eigenWoning = this.createEigenWoningFormGroup();
        this.eigenWoningen.push(eigenWoning);
    }

    deleteEigenWoning(index: number): void {
        this.eigenWoningen.removeAt(index);
        this.eigenWoningFG.updateValueAndValidity();
        this.eigenWoningFG.markAsDirty();
        if (this.eigenWoningen.length === 0) {
            this.eigenWoningen.clear();
        }
        this.saveForm();
    }

    //aankoopkosten
    getAankoopkosten(index: number): FormArray {
        const outerGroup = this.eigenWoningen.at(index) as FormGroup;
        return outerGroup.get('aankoopkosten') as FormArray;
    }

    addAankoopkosten(index: number): void {
        const innerGroup = this.fb.group<OmschrijvingEnBedrag>({
            omschrijving: undefined,
            bedrag: undefined
        });
        const outerGroup = this.eigenWoningen.at(index) as FormGroup;
        const innerArray = outerGroup.get('aankoopkosten') as FormArray;
        innerArray.push(innerGroup);
    }

    deleteAankoopkosten(outerIndex: number, innerIndex: number): void {
        const innerArray = this.getAankoopkosten(outerIndex);
        innerArray.removeAt(innerIndex);
        this.saveForm();
    }

    //verkoopkosten
    getVerkoopkosten(index: number): FormArray {
        const outerGroup = this.eigenWoningen.at(index) as FormGroup;
        return outerGroup.get('verkoopkosten') as FormArray;
    }

    addVerkoopkosten(index: number): void {
        const innerGroup = this.fb.group<OmschrijvingEnBedrag>({
            omschrijving: undefined,
            bedrag: undefined
        });
        const outerGroup = this.eigenWoningen.at(index) as FormGroup;
        const innerArray = outerGroup.get('verkoopkosten') as FormArray;
        innerArray.push(innerGroup);
    }

    deleteVerkoopkosten(outerIndex: number, innerIndex: number): void {
        const innerArray = this.getVerkoopkosten(outerIndex);
        innerArray.removeAt(innerIndex);
        this.saveForm();
    }

    createEigenWoningFormGroup(ew?: OnroerendeZaak): FormGroup {
        return this.fb.group({
            adres: this.createAdresFormGroup(ew?.adres),
            woz: ew?.woz || undefined,
            woznummer: ew?.woznummer || undefined,
            aanhorigheid: ew?.aanhorigheid || false,
            percentageEigendom: ew?.percentageEigendom || 100,
            bewoondePeriode: this.createBewoondePeriodeFormGroup(ew?.bewoondePeriode),
            leegstand: ew?.leegstand || undefined,
            datumGekocht: ew?.datumGekocht || undefined,
            aankoopkosten: this.fb.array<OmschrijvingEnBedrag>([]),
            datumVerkocht: ew?.datumVerkocht || undefined,
            eigenWoningSchuldVerkochteWoning: ew?.eigenWoningSchuldVerkochteWoning || undefined,
            verkoopkosten: this.fb.array<OmschrijvingEnBedrag>([]),
            betaaldeErfpachtCanon: ew?.betaaldeErfpachtCanon || undefined
        });
    }

    public createAdresFormGroup(adres?: Adres) {
        return this.fb.group({
            straat: adres?.straat || undefined,
            huisNummer: adres?.huisNummer || undefined,
            huisNummerToevoeging: adres?.huisNummerToevoeging || undefined,
            postcode: adres?.postcode || undefined,
            woonplaats: adres?.woonplaats || undefined,
            landCode: adres?.landCode || 'NLD'
        });
    }

    public createOmschrijvingEnBedragFormGroup(omschrijving?: OmschrijvingEnBedrag): FormGroup {
        return this.fb.group(({
            omschrijving: omschrijving ? omschrijving.omschrijving : 'Bedrag',
            bedrag: omschrijving ? omschrijving.bedrag : undefined
        } as OmschrijvingEnBedrag));
    }

    trackByFn(index: number): any {
        return index;
    }

    public ngOnInit(): void {
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.aangifte = aangifte;
                this.updateForm();
                this.labelWoz = this.aangifte.aangifteJaar ? `WOZ-waarde 1-1-${this.aangifte.aangifteJaar - 1}` : '';
            }
        });
        this.eigenWoningSubscription = this.eigenWoningFG.valueChanges.subscribe(value => {
            this.formStructure = value;
        });
        this.eigenWoningenSubscription = this.eigenWoningen.valueChanges.subscribe(value => {
            this.eigenWoningLength = value;
        });
        this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) => {
            this.clientId = client.sstRelationId!;
        });
        this.routerSubscription = this.router.events
            .pipe(
                filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.handleUrlChange(event.urlAfterRedirects);
            });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe(); // Unsubscribe from income tax entity
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
        if (this.eigenWoningSubscription) {
            this.eigenWoningSubscription.unsubscribe();
        }
        if (this.eigenWoningenSubscription) {
            this.eigenWoningenSubscription.unsubscribe();
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
        return this.eigenWoningFG.dirty;
    }

    private updateForm(): void {
        const eigenWoningenLijst = this.aangifte?.box1?.belastbareInkomstenUitEigenWoning?.eigenWoningen || [];
        const formArray = this.eigenWoningFG.get('eigenWoningen') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > eigenWoningenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        // Update eigenwoningen
        for (let i = 0; i < eigenWoningenLijst.length; i++) {
            const eigenWoning = eigenWoningenLijst[i];
            if (eigenWoning.adres?.postcode) {
                eigenWoning.adres.postcode = this.formatPostcode(eigenWoning.adres.postcode);
            }

            if (i < formArray.length) {
                const control = formArray.at(i) as FormGroup;
                control.patchValue(eigenWoningenLijst[i]);
            } else {
                const formGroup = this.createEigenWoningFormGroup(eigenWoningenLijst[i]);
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }

        // Update aankoopkosten elke woning (j)
        for (let i = 0; i < eigenWoningenLijst.length; i++) {
            const eigenWoning = eigenWoningenLijst[i];
            const aankoopkosten = eigenWoning.aankoopkosten || [];
            const aankoopkostenFormArray = this.getAankoopkosten(i);

            while (aankoopkostenFormArray.length > aankoopkosten.length) {
                aankoopkostenFormArray.removeAt(aankoopkostenFormArray.length - 1);
            }
            for (let j = 0; j < aankoopkosten.length; j++) {
                if (j < aankoopkostenFormArray.length) {
                    const control = aankoopkostenFormArray.at(j) as FormGroup;
                    control.patchValue(aankoopkosten[j]);
                } else {
                    const aankkosten = this.createOmschrijvingEnBedragFormGroup(aankoopkosten[j]);
                    aankoopkostenFormArray.push(aankkosten);
                }
            }
        }

        // Update verkoopkosten elke woning (k)
        for (let i = 0; i < eigenWoningenLijst.length; i++) {
            const eigenWoning = eigenWoningenLijst[i];
            const verkoopkosten = eigenWoning.verkoopkosten || [];
            const verkoopkostenFormArray = this.getVerkoopkosten(i);

            while (verkoopkostenFormArray.length > verkoopkosten.length) {
                verkoopkostenFormArray.removeAt(verkoopkostenFormArray.length - 1);
            }
            for (let k = 0; k < verkoopkosten.length; k++) {
                if (k < verkoopkostenFormArray.length) {
                    const control = verkoopkostenFormArray.at(k) as FormGroup;
                    control.patchValue(verkoopkosten[k]);
                } else {
                    const verkoopk = this.createOmschrijvingEnBedragFormGroup(verkoopkosten[k]);
                    verkoopkostenFormArray.push(verkoopk);
                }
            }
        }
    }

    saveForm(): void {
        this.eigenWoningFG.updateValueAndValidity();
        setTimeout(() => {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                box1: {
                    ...this.aangifte.box1,
                    belastbareInkomstenUitEigenWoning: {
                        ...this.aangifte.box1?.belastbareInkomstenUitEigenWoning,
                        eigenWoningen: this.eigenWoningFG.value.eigenWoningen
                    }
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
            this.eigenWoningFG.markAsDirty();
        }, 0);
    }

    private createBewoondePeriodeFormGroup(bewoondePeriode?: Periode) {
        const incomeTaxEntity = this.incomeTaxEntity;
        if (incomeTaxEntity.aangifte && incomeTaxEntity.aangifte.aangifteJaar) {
            let aangifte = {} as Aangifte;
            aangifte = incomeTaxEntity.aangifte;
            const utcDate = new Date(Date.UTC(aangifte.aangifteJaar, 0, 1, 12, 0, 0));
            const utcDateEind = new Date(Date.UTC(aangifte.aangifteJaar, 11, 31, 12, 0, 0));
            return this.fb.group({
                begindatum: [bewoondePeriode?.begindatum || utcDate],
                einddatum: [bewoondePeriode?.einddatum || utcDateEind]
            });
        }
        return this.fb.group({
            begindatum: [bewoondePeriode?.begindatum || null],
            einddatum: [bewoondePeriode?.einddatum || null]
        });
    }

    formatPostcode(postcode: string | null | undefined): string {
        if (!postcode) return ''; // Retourneer een lege string als postcode null of undefined is

        // Verwijder alle niet-alfanumerieke tekens (bijv. spaties)
        const cleanedPostcode = postcode.replace(/[^a-zA-Z0-9]/g, '');

        // Zorg voor 4 cijfers en 2 hoofdletters
        if (cleanedPostcode.length >= 4) {
            const cijfers = cleanedPostcode.substring(0, 4).replace(/\D/g, ''); // Alleen cijfers
            const letters = cleanedPostcode.substring(4, 6).replace(/[^a-zA-Z]/g, '').toUpperCase(); // Alleen letters
            return `${cijfers}${letters}`;
        }

        return cleanedPostcode; // Als de postcode te kort is, retourneer de schoongemaakte versie
    }
}
